import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    clienteFacturacionId: 0,
    clienteFacturacion: null,
    clienteFacturacionNombre: null,
    presupuestoInternoId: 0,
    presupuestoNumero: '',
    cliente: '',
    accion: '',
    clienteContacto: '',
    //descripcion: '',
    monedaId: 0,
    moneda: '',
    importe: 0,
    observaciones: '',
    renglones: [],
    rowVersion: null,

    saldoCertificar: 0,

    /* Vista de datos */
    certificadoDatos: [],
    renglonesDatos: [],

    /* Datos del certificado (PDF / Excel) */
    certificadoDatosRpt: {},
};

const mutations = {
    updateField,

    'INICIALIZAR_CERTIFICADO' (state, params) {
        state.id = params.certificadoServicioId | 0;
        state.clienteFacturacionId = 0;
        state.clienteFacturacion = null;
        state.clienteFacturacionNombre = null;
        state.presupuestoInternoId = params.presupuestoId;
        state.presupuestoNumero = '';
        state.cliente= '';
        state.accion= '';
        state.clienteContacto= '';
        state.moneda = '';
        //state.descripcion = '';

        state.importe = 0;
        state.observaciones = '';
        state.rowVersion = null;
        state.renglones= [];

        state.saldoCertificar = 0;
    },
    'SET_CERTIFICADO' (state, certificado) {
        state.clienteFacturacionId = certificado.clienteFacturacion? certificado.clienteFacturacion.id : 0;
        state.clienteFacturacion = certificado.clienteFacturacion;
        state.clienteFacturacionNombre = certificado.clienteFacturacion? certificado.clienteFacturacion.nombre.trim() : null;

        state.presupuestoInternoId = certificado.presupuestoInternoId;
        state.presupuestoNumero = certificado.presupuestoNumero;
        state.cliente= certificado.cliente.trim();
        state.accion= certificado.accion.trim();
        state.clienteContacto= certificado.clienteContacto? certificado.clienteContacto.trim() : '';
        //state.descripcion = certificado.descripcion.trim();
        state.moneda = certificado.moneda.trim();
        state.importe = parseFloat(certificado.importe);
        state.observaciones = certificado.observaciones.trim();
        state.rowVersion = certificado.rowVersion;
        
        state.renglones= certificado.renglones.map(renglon => ({
            ...renglon, 
            moneda: certificado.moneda.trim(),
            importe: parseFloat(renglon.importe),
            pjeCertificado: parseFloat(renglon.pjeCertificado),
            pjeMaximoCertificar: parseFloat(renglon.pjeMaximoCertificar)
        }));

        /* Calculamos el saldo total a certificar */
        state.saldoCertificar = state.renglones
            .reduce((importe, renglon) => importe + helpers.methods.roundToTwo(renglon.importeNeto * renglon.pjeMaximoCertificar), 0);
    },
    'SET_CLIENTEFACTURACION'(state, clienteFacturacion) {
        state.clienteFacturacionId = clienteFacturacion? clienteFacturacion.id : 0;
        state.clienteFacturacion = clienteFacturacion;
        state.clienteFacturacionNombre = clienteFacturacion? clienteFacturacion.nombre.trim() : null;
    },

    'UPDATE_PJE_CERTIFICADO_RENGLON' (state, params) {
        let renglon = state.renglones.find( r => r.ordenTrabajoId == params.ordenTrabajoId);
        if (renglon) {
            renglon.pjeCertificado = parseFloat(params.pjeCertificado);
            renglon.importe =  helpers.methods.roundToTwo(parseFloat(renglon.importeNeto) * parseFloat(renglon.pjeCertificado) / 100);
        }

        state.importe = state.renglones
            .reduce((importe, renglon) => importe + renglon.importe, 0);
    },
    'UPDATE_IMPORTE_RENGLON' (state, params) {
        let renglon = state.renglones.find( r => r.ordenTrabajoId == params.ordenTrabajoId);
        if (renglon) {
            renglon.importe = parseFloat(params.importe);
            renglon.pjeCertificado = helpers.methods.roundToTwo(parseFloat(params.importe / renglon.importeNeto * 100));
        }

        state.importe = state.renglones
            .reduce((importe, renglon) => importe + renglon.importe, 0);
    },
    'SET_IMPORTE_TOTAL' (state, importeTotal) {
        /* Calculamos el importe proporcional por cada renglón */
        state.renglones.forEach(renglon => {
            let saldoRenglon = helpers.methods.roundToTwo(renglon.importeNeto * renglon.pjeMaximoCertificar);
            let importeCertificar = helpers.methods.roundToTwo(importeTotal * saldoRenglon / state.saldoCertificar)

            /* Actualizamos los valores del renglón */
            renglon.importe = importeCertificar;
            renglon.pjeCertificado = helpers.methods.roundToTwo(importeCertificar / renglon.importeNeto * 100);
        });
        
        /* Actualizamos los totales del certificado */
        state.importe = state.renglones
            .reduce((importe, renglon) => importe + renglon.importe, 0);
    },

    'INICIALIZAR_DATOS' (state) {
        state.certificadoDatos = [];
        state.renglonesDatos = [];
    },
    'SET_DATOS' (state, params) {
        state.certificadoDatos = params.certificadoDatos;
        state.renglonesDatos = params.renglonesDatos.map(renglon => ({ ...renglon, moneda: params.certificadoDatosRpt.moneda.trim() }));

        // let numeroPresupuesto = params.certificadoDatosRpt.presupuestoInternoId;
        let numeroPresupuesto = params.certificadoDatosRpt.presupuestoNumero;
        let numeroCertificado = params.certificadoDatosRpt.id;
        let numeroOrdenCompra = params.certificadoDatosRpt.numeroOrdenCompra.trim();
        let descripcionOrdenCompra = params.certificadoDatosRpt.descripcionOrdenCompra.trim();
        let fecha = params.certificadoDatosRpt.fechaRegistro;
        let cliente = params.certificadoDatosRpt.cliente.trim();
        let accion = params.certificadoDatosRpt.accion.trim();
        let razonSocial = params.certificadoDatosRpt.clienteRazonSocial.trim();
        let condicionFiscal = params.certificadoDatosRpt.condicionFiscal.trim();
        let documentoTipo = params.certificadoDatosRpt.clienteDocumentoTipo.trim();
        let documentoNumero = params.certificadoDatosRpt.clienteDocumentoNumero;
        if (params.certificadoDatosRpt.clienteDocumentoTipoId == 2) {
            documentoNumero = helpers.methods.formattedCuit(params.certificadoDatosRpt.clienteDocumentoNumero);    
        // } else if (params.certificadoDatosRpt.clienteDocumentoTipoId == 4) {
        //     /* TIN / EIN */
        //     documentoNumero = helpers.methods.formattedEIN(params.certificadoDatosRpt.clienteDocumentoNumero);    
        }
        let showLocalidad = true;
        if (params.certificadoDatosRpt.clientePaisId != 1) {
            showLocalidad = false;
        }
        let showLeyendaIVA = true;
        if (params.certificadoDatosRpt.condicionFiscalId == 3) {
            showLeyendaIVA = false;
        }
        // let cuit = '';
        let direccion = params.certificadoDatosRpt.clienteDireccion.trim();
        let localidad = params.certificadoDatosRpt.clienteLocalidad.trim();
        let provincia = params.certificadoDatosRpt.clienteProvincia.trim();
        let pais = params.certificadoDatosRpt.clientePais.trim();
        let contacto = params.certificadoDatosRpt.clienteContacto.trim();
        let discriminarFee = params.certificadoDatosRpt.discriminarFee;
        let moneda = params.certificadoDatosRpt.moneda.trim();

        let showLeyendaDescuento = false;
        if (params.certificadoDatosRpt.presupuestoPjeDescuento != 0) {
            showLeyendaDescuento = true;
        }

        state.certificadoDatosRpt = {
            numeroPresupuesto,
            numeroCertificado,
            numeroOrdenCompra,
            descripcionOrdenCompra,
            fecha,
            cliente,
            accion,
            clienteRazonSocial: razonSocial,
            clienteCondicionFiscal: condicionFiscal,
            clienteDocumentoTipo: documentoTipo,
            clienteDocumentoNumero: documentoNumero,
            // 'clienteCuit': cuit,
            clienteDireccion: direccion,
            clienteLocalidad: localidad,
            clienteProvincia: provincia,
            clientePais: pais,
            contacto,
            discriminarFee,
            moneda,
            showLocalidad,
            showLeyendaIVA,
            showLeyendaDescuento
        };
    },
};

const getters = {
    getField,

    certificadoDatosRpt (state) {
        return state.certificadoDatosRpt;
    },
    renglonesDatos (state) {
        return state.renglonesDatos;
    },
    tieneSaldoCertificar(state) {
        /* Margen permitido de hasta 0.5% para cerrar el presupuesto */
        let margen = 0.5;

        return state.renglones.some(renglon => Math.abs(renglon.pjeCertificado - renglon.pjeMaximoCertificar) > margen);
    }
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CERTIFICADO', params);

            let getCertificado = false;
            let presupuestoId = 0;
            let certificadoServicioId = 0;
            if (params) {
                if (params.certificadoServicioId) {
                    if (params.certificadoServicioId != 0) {
                        getCertificado = true;
                        certificadoServicioId = params.certificadoServicioId;
                    }
                }
                if (params.presupuestoId) {
                    if (params.presupuestoId != 0) {
                        getCertificado = true;
                        presupuestoId = params.presupuestoId;
                    }
                }
            }

            if (getCertificado) {
                let url = '';
                if (certificadoServicioId != 0) {
                    url = `certificadosservicio/${certificadoServicioId}/abm`;
                } else {
                    url = `certificadosservicio/presupuesto/${presupuestoId}`;
                }

                apiAxios.get(url) 
                .then(res => {
                    commit('SET_CERTIFICADO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
    save ( { state }, fechaCierrePresupuesto ) {
        return new Promise((resolve, reject) => {
            let isValid = true;
            let errorMessage = '';
            
            if (parseFloat(state.importe) == 0) {
                isValid = false;
                errorMessage = 'No se puede registrar un certificado con importe igual a cero';
            }

            /* Validamos el pje a certificar por cada renglon */
            for (let key in state.renglones){
                const renglon = state.renglones[key];
                if ( parseFloat(renglon.pjeCertificado) > 100 || parseFloat(renglon.pjeCertificado) < 0) {
                    isValid = false;
                    errorMessage = 'El porcentaje a certificar por cada renglon no puede ser superior al 100%.';
                } else if ( parseFloat(renglon.pjeCertificado) > parseFloat(renglon.pjeMaximoCertificar) ) {
                    isValid = false;
                    errorMessage = 'El porcentaje a certificar por cada renglon no puede superar el saldo a certificar.';
                }
            }

            if (isValid) {
                let renglones = state.renglones.map(renglon => ({
                    ordenTrabajoId: renglon.ordenTrabajoId,
                    pjeCertificado: parseFloat(renglon.pjeCertificado),
                    importe: parseFloat(renglon.importe),
                    // pjeCertificadoCotizacion: parseFloat(renglon.pjeCertificadoCotizacion),
                    // pjeCertificadoFinanciacion: parseFloat(renglon.pjeCertificadoFinanciacion),
                    // pjeCertificadoFeeAgencia: parseFloat(renglon.pjeCertificadoFeeAgencia),
                    // importeCotizacion: parseFloat(renglon.importeCotizacion),
                    // importeFinanciacion: parseFloat(renglon.importeFinanciacion),
                    // importeFeeAgencia: parseFloat(renglon.importeFeeAgencia),
                    ordenTrabajoCotizacion: parseFloat(renglon.ordenTrabajoCotizacion),
                    ordenTrabajoFinanciacion: parseFloat(renglon.ordenTrabajoFinanciacion),
                    ordenTrabajoFeeAgencia: parseFloat(renglon.ordenTrabajoFeeAgencia)
                }))

                let certificado= {
                    presupuestoInternoId: parseInt(state.presupuestoInternoId),
                    clienteFacturacionId: parseInt(state.clienteFacturacionId),
                    importe: parseFloat(state.importe),
                    observaciones: state.observaciones.trim(),
                    renglones
                };

                if (fechaCierrePresupuesto) {
                    certificado.fechaCierrePresupuesto = moment(fechaCierrePresupuesto).format('YYYY-MM-DD');
                }

                let url = 'certificadosservicio';

                if (state.id != 0) {
                    certificado.rowVersion = state.rowVersion;
                    url += '/' + state.id;
                } 
    
                apiAxios.post(url, certificado)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
                } else {
                    reject(errorMessage);
                }
            })
    },
    setClienteFacturacion: ({commit}, clienteFacturacion) => {
        commit('SET_CLIENTEFACTURACION', clienteFacturacion);
    },
    getDatos ( { commit }, certificadoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (certificadoId) {
                apiAxios.get(`certificadosservicio/${certificadoId}` ) 
                    .then(res => {
                        let renglonesDatos = res.data.renglones;
                        
                        let params = {
                            certificadoDatos: res.data,
                            renglonesDatos,
                            certificadoDatosRpt: res.data
                        }
                        
                        commit('SET_DATOS', params);
                        resolve();
                    })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    updatePjeCertificado: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_PJE_CERTIFICADO_RENGLON', params);
            resolve();
        })
    },
    updateImporteCertificado: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_IMPORTE_RENGLON', params);
            resolve();
        })
    },
    setImporteTotal: ( { state, commit }, importeTotal) => {
        return new Promise((resolve, reject) => {
            if (importeTotal <= state.saldoCertificar) {
                commit('SET_IMPORTE_TOTAL', importeTotal);
                resolve();
            } else {
                reject('El importe total no puede ser mayor al saldo a certificar');
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}